module.exports = __webpack_public_path__ + "img/ribbon.7547ee1a.svg";